/**
 * View models of the customer screens (TO-418 customer-ui). The views are pure:
 * the page hook maps API DTOs into these shapes and passes a `t` translate
 * function, so no view touches i18n, data fetching or business rules.
 */

/** Translate a catalog key (react-i18next's `t`, or a stub in stories/tests). */
export type Translate = (key: string, vars?: Record<string, string | number>) => string

export interface Option {
	id: string
	label: string
}

export interface CustomerRowView {
	id: string
	fullName: string
	type: 'lead' | 'customer'
	status: 'active' | 'inactive'
	primaryEmail: string | null
	primaryMobile: string | null
	tags: string[]
	orgUnitName: string
	assignedUserName: string | null
	createdAt: string
}

/** The list's server-sortable columns — also the `sort` values `GET /customers` accepts (TO-697). */
export enum CustomerSortKey {
	FULL_NAME = 'fullName',
	CREATED_AT = 'createdAt',
}

export interface CustomerFilters {
	type: string
	status: string
	orgUnitId: string
	tags: string
	search: string
}

export interface ContactPointView {
	id: string
	type: 'email' | 'mobile' | 'landline'
	value: string
	label: string
	isPrimary: boolean
	verified: boolean
	invalid: boolean
}

export interface AssignmentView {
	id: string
	orgUnitName: string
	userName: string | null
	reason: string
	from: string
	to: string | null
}

export interface NoteView {
	id: string
	body: string
	author: string
	createdAt: string
	edited: boolean
	isOwn: boolean
}

export interface ConsentView {
	id: string
	channel: string
	purpose: string
	status: string
	legalText: string | null
	evidence: string | null
	evidenceRedacted: boolean
	effectiveAt: string
}
